import { useSelector } from 'react-redux';
import { find } from 'lodash';
import selectors from 'store/selectors';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';

export const useUserDefaultLocation = () => {
  const { workspaceId } = useWorkspaceHook();
  const userProfileData: any = useSelector(selectors.getUserProfile);
  const authLocationsHash = useSelector(selectors.getAuthLocationsHash);

  const getUserDefaultLocation = () => {
    const { UserHotels } = userProfileData;
    const currentUserHotel = find(
      UserHotels,
      (userHotel) => userHotel.Hotel.id === workspaceId,
    );

    const { defaultLocationId } = currentUserHotel || {};
    const isExists = authLocationsHash?.[defaultLocationId];

    return isExists ? defaultLocationId : null;
  };

  return {
    getUserDefaultLocation,
  };
};
